module.exports = __webpack_public_path__ + "img/loading.d74c879a.gif";